import { render, staticRenderFns } from "./CustomCodes.vue?vue&type=template&id=20f08a2a&"
import script from "./CustomCodes.vue?vue&type=script&lang=js&"
export * from "./CustomCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports